import { ShoppingBag } from "lucide-react";

const T = {
  cart: { lv: "Grozs", ru: "Корзина", en: "Cart" },
  view: { lv: "Skatīt grozu", ru: "Открыть корзину", en: "View cart" },
};

const eur = (v) => `€${Number(v).toFixed(2)}`;

export const FloatingCartBar = ({ language, count, total, onClick }) => {
  if (!count) return null;
  const t = (k) => T[k][language] || T[k].lv;
  return (
    <div className="fixed inset-x-0 bottom-0 z-40 px-4 pb-4 sm:px-0 sm:pb-0 sm:inset-x-auto sm:right-8 sm:bottom-8 pointer-events-none" data-testid="floating-cart-bar">
      <button
        onClick={onClick}
        className="pointer-events-auto w-full sm:w-auto min-h-[56px] flex items-center justify-between sm:justify-start gap-6 px-6 bg-[#1C1917] text-[#FDFBF7] shadow-[0_24px_48px_-16px_rgba(28,25,23,0.5)] text-[0.72rem] font-medium tracking-[0.2em] uppercase hover:bg-[#C2410C] transition-colors font-body"
        aria-label={`${t("view")} · ${count} · ${eur(total)}`}
        data-testid="floating-cart-button"
      >
        <span className="inline-flex items-center gap-3">
          <ShoppingBag className="w-[18px] h-[18px]" strokeWidth={1.5} aria-hidden="true" />
          {t("cart")} · <span data-testid="floating-cart-count">{count}</span>
        </span>
        <span className="tracking-normal text-base font-semibold tabular-nums" data-testid="floating-cart-total">{eur(total)}</span>
      </button>
    </div>
  );
};
